/* app/js/src/components/channel/channel-wizard/step1/drag-image.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: flex-end;
  -ms-flex-align: flex-end;
  align-items: flex-end;
}
.box-drag {
  width: 141px;
  height: 103px;
  border: 1px dashed #c6d2df;
  position: relative;
  cursor: pointer;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.box-drag label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  cursor: pointer;
}
.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.drag-here {
  text-align: center;
  width: 100%;
  color: #c6d2df;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.drag-here i ::ng-deep svg {
  height: 39px;
  fill: #c6d2df;
}
.drag-here p {
  margin: 10px 0 0 0;
}
:host(.empty) .box-drag:hover,
:host(.empty) .box-drag.drag {
  border: 1px solid #879baf;
}
:host(.empty) .box-drag:hover .drag-here,
:host(.empty) .box-drag.drag .drag-here {
  color: #879baf;
}
:host(.uploading) .box-drag,
:host(.has-image) .box-drag {
  border: 1px solid #232f3a;
}
.trash {
  margin-left: 15px;
  cursor: pointer;
}
.trash:hover ::ng-deep svg path {
  fill: #232f3a !important;
}
:host(.empty) .trash,
:host(.uploading) .trash {
  visibility: hidden;
}
/*# sourceMappingURL=drag-image.component.css.map */
